// Catálogo único de tipos "mencionables" con @ en Mensajería Interna.
// Mismos alias que el morph map del backend (MessagesServiceProvider::MENTIONABLE_TYPES) —
// agregar/sacar un tipo es tocar este archivo (y su contraparte en el
// backend), nada más: ni el chip, ni el buscador de @, ni la pantalla de
// "buscar por referencia" necesitan cambios propios cuando cambia esta lista.
//
// route/routeParam son opcionales: si un tipo no tiene una vista de detalle
// propia todavía, el chip queda visual (con su tooltip) pero sin click de
// navegación, en vez de armar un link roto.
const mentionable = {
  customer: {
    label: 'Cliente',
    icon: 'building',
    route: 'CustomerViewStaff',
    routeParam: 'customersID',
  },
  supplier: {
    label: 'Proveedor',
    icon: 'truck',
    route: 'SuppliersViewStaff',
    routeParam: 'suppliersID',
  },
  product: {
    label: 'Producto',
    icon: 'box-seam',
  },
  project: {
    label: 'Proyecto',
    icon: 'kanban',
  },
  service: {
    label: 'Servicio',
    icon: 'tools',
  },
  hours: {
    label: 'Horas de proyecto',
    icon: 'clock-history',
  },
  server: {
    label: 'Servidor',
    icon: 'hdd-rack',
  },
  instance: {
    label: 'Instancia',
    icon: 'diagram-3',
  },
  task: {
    label: 'Tarea',
    icon: 'list-task',
  },
}

export function getMentionableConfig(type) {
  return mentionable[type] || { label: type, icon: 'tag' }
}

export function getMentionableTypes() {
  return Object.keys(mentionable).map((key) => ({ value: key, ...mentionable[key] }))
}

export default mentionable
